import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FiltroExportacao from "./components/ExportFilter";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function Exportar() {
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [open, setOpen] = useState(false);

  const handleShowAlert = (type, message) => {
    setAlert({ type, message });
    setOpen(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <FiltroExportacao onAlert={handleShowAlert} />
      <Snackbar open={open} autoHideDuration={3000} onClose={() => setOpen(false)}>
        <MuiAlert
          onClose={() => setOpen(false)}
          severity={alert.type}
          elevation={6}
          variant="filled"
        >
          {alert.message}
        </MuiAlert>
      </Snackbar>
      <Footer />
    </DashboardLayout>
  );
}

export default Exportar;
